import { render, staticRenderFns } from "./VerifiedTextArea.vue?vue&type=template&id=346a1cc4&scoped=true"
import script from "./VerifiedTextArea.vue?vue&type=script&lang=js"
export * from "./VerifiedTextArea.vue?vue&type=script&lang=js"
import style0 from "./VerifiedTextArea.vue?vue&type=style&index=0&id=346a1cc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346a1cc4",
  null
  
)

export default component.exports